/* eslint  max-len: 0 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import '../../../styles/_sports.scss';
import { getTournamentMatches } from 'redux/tournament-matches/tournamentMatchesSlice';
import translationKeys from 'translations/translationKeys';
import Loading from 'components/common/Loading';
import Error from 'components/common/Error';
import PropTypes from 'prop-types';
import SportItem from './SportItem';

const UniversalComponent = ({ isMobile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { msg154 } = translationKeys;
  const {
    tournamentMatches, isLoading, error, successGetTournamentMatches,
  } = useSelector((store) => store.tournamentMatches);
  const { sportSelected } = useSelector((store) => store.allSports);
  const { lang } = useSelector((store) => store.language);
  const { topMatchesMkts, isLoading: isTopMatchesLoading } = useSelector((store) => store.topMatchesMkts);
  const [markets, setMarkets] = useState([]);

  const tournamentId = JSON.parse(localStorage.getItem('tournamentId')); // Set in LeftSideBar.jsx
  let marketId = localStorage.getItem('marketId') || '1'; // Set below

  // change markets once the selected Sport has change and once we start loading the tournament matches
  useEffect(() => {
    if (Object.keys(topMatchesMkts).length && isLoading && sportSelected?.id) {
      let sport1Markets = topMatchesMkts[sportSelected.id];
      if (!sport1Markets) {
        sport1Markets = [];
      }
      setMarkets(sport1Markets.map((item) => JSON.parse(item)));
    }
  }, [topMatchesMkts, sportSelected, isLoading, dispatch]);

  // When page is refreshed and path is /dashboard/matches, call tournament matches.
  useEffect(() => {
    if (pathname === '/dashboard/matches') {
      dispatch(getTournamentMatches({ tournamentId, marketId: marketId || '' }));
      if (marketId === null) {
        marketId = '';
        localStorage.setItem('marketId', marketId);
      }
    }
  }, [pathname, successGetTournamentMatches, lang, dispatch]);
  return (
    <div className="list-dashboard">
      <div className="content-wrap">
        <div className={`tab-content ${markets?.length === 0 ? 'no-nav' : ''} `}>
          <div className="zone-nav">
            <ul className="market-list">
              {markets?.length > 0 ? markets.map((item) => item && (
              <li className={`nav-item list-inline-item${marketId === item.marketId ? ' active' : ''}`} role="presentation" key={uuidv4()}>
                <button
                  type="button"
                  className="nav-link"
                  onClick={() => {
                    // localStorage.setItem('marketSelected', JSON.stringify(item));
                    localStorage.setItem('marketId', item.marketId); // To be used refetch tournament matches when page is refreshed
                    dispatch(getTournamentMatches({ tournamentId, marketId: item.marketId }));
                    navigate('/dashboard/matches');
                  }}
                >
                  {item.marketNameTranslate[lang]}
                </button>
              </li>
              )) : null}
              {isTopMatchesLoading ? <Loading /> : null}
            </ul>
          </div>
          <div className="tab-content list">
            {isLoading ? <Loading /> : null}
            {error && !isLoading ? <Error text={t(error)} /> : null}
            {(!isLoading && !error) ? (
              <ul className="match-list">
                {(tournamentMatches?.length > 0 ? tournamentMatches.map((item) => {
                  const { matches } = item;
                  return matches?.length > 0 ? matches.map((m) => <SportItem event={m} key={m.id} isMobile={isMobile} redirect="/dashboard/matches" />) : null;
                }) : <Error text={t(msg154)} />)}
              </ul>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

UniversalComponent.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default UniversalComponent;
